import { createAction, props } from '@ngrx/store';

import { Investment } from '../../investments/investments.interface';

export const setSharePrice = createAction('[Transfer Component] Set Share Price', props<{ sharePrice: number }>());

export const setPitchInvestments = createAction('[Transfer Component] Set Pitch Investments', props<{ investments: Investment[] }>());

export const updateInvestments = createAction('[Transfer Component] Update Investments', props<{ investments: Investment[] }>());

export const updateManyInvestments = createAction(
  '[Transfer Component] Update many Investments',
  props<{ investments: { ids: string[]; changes: Partial<Investment> } }>()
);

export const updateInvestmentsStatus = createAction('[Transfer Component] Update Investments Status');

export const setPNR = createAction('[Transfer Component] Set PNR', props<{ pnr: string; userId: string }>());

export const switchSelection = createAction('[Transfer Component] Switch Selection', props<{ investment: Investment; name: string }>());

export const switchAllSelection = createAction('[Transfer Component] Switch All Selection', props<{ checked: boolean }>());

export const selectInvestmentsByStatus = createAction('[Transfer Component] Select Investments By Status', props<{ status: string }>());

export const resetTransferState = createAction('[Transfer Component] Reset Transfer State');

// Requests

export const loadTransfer = createAction('[Request/Api Transfer] Load Transfer', props<{ id: string }>());

export const loadPitchInvestments = createAction('[Request/Api Transfer] Load Pitch Investments', props<{ id: string }>());

export const changeSharesNumber = createAction(
  '[Request/Api Transfer] Change Shares Number',
  props<{ payload: { ids: string[]; shares: number; declaredSharesNumber: number } }>()
);

export const changePitchInvestmentsPaidStatus = createAction(
  '[Request/Api Transfer] Change Pitch Investments Paid Status',
  props<{ payload: { ids: string[]; paid: string } }>()
);

export const changePitchInvestmentsStatus = createAction(
  '[Request/Api Transfer] Change Pitch Investments Status',
  props<{ payload: { ids: string[]; status: string } }>()
);

export const acceptAllPendingInvestments = createAction('[Request/Api Transfer] Accept All Pending Investments', props<{ id: string }>());
